import { isEmpty } from "lodash";
import { t } from "@/i18n-js/instance";
import { Form } from "@circle-react-uikit/Form";
import { EditorCollapsable } from "../../../../Editor/EditorCollapsable";
import { useCustomColors } from "../../../../ThemeConfiguration/hooks/useCustomColors";
import type { ButtonVariant } from "./ButtonStateSelector";
import { generateFormItemName } from "./Styles";

interface BackgroundProps {
  selectedButtonVariant: ButtonVariant;
}

export const Background = ({ selectedButtonVariant }: BackgroundProps) => {
  const {
    flattenedCssVariables,
    themeColors,
    customColors,
    handleAddCustomColor,
  } = useCustomColors();
  return (
    <EditorCollapsable
      title={t("builder_ui.prop_type.styles.background")}
      defaultOpen
    >
      <div className="px-6 py-5">
        <Form.Item
          name={generateFormItemName(selectedButtonVariant, "backgroundColor")}
          label={t("builder_ui.prop_type.styles.background_color")}
          hideDescription
          hideBorder
          labelClassName="!font-normal !text-xs"
          className="!flex !w-full !items-center !justify-between !p-0"
        >
          <Form.ColorPickerV2
            name={generateFormItemName(
              selectedButtonVariant,
              "backgroundColor",
            )}
            cssVariables={flattenedCssVariables}
            shouldResolveCssVariable={Boolean(flattenedCssVariables)}
            shouldRenderThemeColors={!isEmpty(themeColors)}
            themeColors={themeColors}
            customColors={customColors}
            onAddCustomColor={
              !isEmpty(themeColors) ? handleAddCustomColor : undefined
            }
          />
        </Form.Item>
      </div>
    </EditorCollapsable>
  );
};
